var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStockRequest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43,
    height: 32,
    viewBox: "0 0 43 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#0885d5;}.b{fill:#ff4e4e;}.c{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-395 -152)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 16,
    cy: 16,
    r: 16,
    transform: "translate(395 152)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 9,
    cy: 9,
    r: 9,
    transform: "translate(420 152)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M-441.154,1313.156a.531.531,0,0,0-.6-.106l-15.939,7.438a.531.531,0,0,0-.307.484.531.531,0,0,0,.312.481l5.663,2.574,2.574,5.663a.531.531,0,0,0,.481.312h0a.531.531,0,0,0,.481-.307l7.438-15.939A.531.531,0,0,0-441.154,1313.156Zm-2.884,2.132-7.7,7.7-4.459-2.027Zm-4.924,12.913-2.027-4.459,7.7-7.7Z",
    transform: "translate(860.499 -1153.001)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(423.409 155)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M12.707,5a.532.532,0,0,0-.147.038L7.331,7.178a.537.537,0,0,0-.331.5v6.7a.536.536,0,0,0,.331.494l5.23,2.146a.535.535,0,0,0,.411,0l5.23-2.146a.536.536,0,0,0,.331-.494v-6.7a.537.537,0,0,0-.331-.5l-5.23-2.146A.535.535,0,0,0,12.707,5Zm.059,1.115,3.813,1.567L12.766,9.24,8.953,7.677ZM8.073,8.477l4.157,1.705v5.54L8.073,14.017Zm9.387,0v5.54L13.3,15.723v-5.54l4.157-1.705Z",
    transform: "translate(-7 -4.992)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStockRequest);
export default __webpack_public_path__ + "static/media/stock-request.df3019bf5dbeb8ece37e08c634c44c6a.svg";
export { ForwardRef as ReactComponent };